"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rules_1 = require("./rules");
var addresses_1 = require("./addresses");
var create = function (network) {
    var addresses = network === "mainnet" ? addresses_1.mainnet : addresses_1.testnet;
    var rules = rules_1.createMirrorRules(addresses);
    var openPositionRuleSet = {
        rule: rules.openPosition,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/open-position",
            canonicalMsg: [
                "Deposit " + matched[4].value + " (Position ID: " + matched[0] + ")",
                "Mint " + matched[3].value,
            ],
            payload: fragment,
        }); },
    };
    var depositRuleSet = {
        rule: rules.depositRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/deposit",
            canonicalMsg: [
                "Deposit " + matched[3].value + " (Position ID: " + matched[2].value + ")",
            ],
            payload: fragment,
        }); },
    };
    var withdrawRuleSet = {
        rule: rules.withdrawRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/withdraw",
            canonicalMsg: [
                "Withdraw " + matched[3].value + " (Position ID: " + matched[2].value + ")",
            ],
            payload: fragment,
        }); },
    };
    var burnRuleSet = {
        rule: rules.burnRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/burn",
            canonicalMsg: [
                "Burn " + matched[8].value + " (Position ID: " + matched[7].value + ")",
            ],
            payload: fragment,
        }); },
    };
    var stakeLPRuleSet = {
        rule: rules.stakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/stake-LP",
            canonicalMsg: ["Stake " + matched[8].value + matched[0].value],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSet = {
        rule: rules.unstakeLPRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unstake-LP",
            canonicalMsg: ["Unstake " + matched[8].value + matched[4].value],
            payload: fragment,
        }); },
    };
    var unstakeLPRuleSetTypeB = {
        rule: rules.unstakeLPRuleTypeB,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unstake-LP",
            canonicalMsg: ["Unstake " + matched[9].value + matched[5].value],
            payload: fragment,
        }); },
    };
    var lpStakingRewardRuleSet = {
        rule: rules.lpStakingRewardRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/LP-staking-reward",
            canonicalMsg: ["Claim Reward " + matched[7].value + matched[3].value],
            payload: fragment,
        }); },
    };
    var govStakeRuleSet = {
        rule: rules.govStakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/governance-stake",
            canonicalMsg: [
                "Stake " + matched[4].value + matched[0].value + " to " + matched[5].value,
            ],
            payload: fragment,
        }); },
    };
    var govUnstakeRuleSet = {
        rule: rules.govUnstakeRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/governance-unstake",
            canonicalMsg: [
                "Unstake " + matched[3].value + matched[4].value + " to " + matched[0].value,
            ],
            payload: fragment,
        }); },
    };
    var createPollRuleSet = {
        rule: rules.createPollRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/create-poll",
            canonicalMsg: ["Create Poll (Poll ID: " + matched[8].value + ")"],
            payload: fragment,
        }); },
    };
    var castVoteRuleSet = {
        rule: rules.castVoteRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/cast-vote",
            canonicalMsg: [
                "Vote to Poll (Poll ID: " + matched[2].value + ") (" + matched[5].value + ")",
            ],
            payload: fragment,
        }); },
    };
    var airdropRuleSet = {
        rule: rules.airdropRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/airdrop",
            canonicalMsg: ["Claim " + matched[4].value + matched[5].value],
            payload: fragment,
        }); },
    };
    var buySubmitOrderRuleSet = {
        rule: rules.buySubmitOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/submit-order-buy",
            canonicalMsg: [
                "Order to buy " + matched[5].value + " with " + matched[4].value,
            ],
            payload: fragment,
        }); },
    };
    var sellSubmitOrderRuleSet = {
        rule: rules.sellSubmitOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/submit-order-sell",
            canonicalMsg: [
                "Order to sell " + matched[9].value + " for " + matched[10].value,
            ],
            payload: fragment,
        }); },
    };
    var cancelOrderRuleSet = {
        rule: rules.cancelOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/cancel-order",
            canonicalMsg: ["Canceled limit order ID:" + matched[2].value],
            payload: fragment,
        }); },
    };
    var buyExecuteOrderRuleSet = {
        rule: rules.buyExecuteOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/execute-order-buy",
            canonicalMsg: ["Bought " + matched[9].value + " with " + matched[8].value],
            payload: fragment,
        }); },
    };
    var sellExecuteOrderRuleSet = {
        rule: rules.sellExecuteOrderRule,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/execute-order-sell",
            canonicalMsg: ["Sold " + matched[3].value + " for " + matched[4].value],
            payload: fragment,
        }); },
    };
    var lpStakeRuleSet = {
        rule: rules.longFarm,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/LP-stake",
            canonicalMsg: ["Stake LP to " + matched[0].value],
            payload: fragment,
        }); },
    };
    var borrowRuleSet = {
        rule: rules.borrow,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/borrow",
            canonicalMsg: ["Mint " + matched[3].value + " with " + matched[4].value],
            payload: fragment,
        }); },
    };
    var unlockAmountRuleSet = {
        rule: rules.unlockAmount,
        transform: function (fragment, matched) { return ({
            msgType: "mirror/unlock-amount",
            canonicalMsg: ["Unlock " + matched[2].value],
            payload: fragment,
        }); },
    };
    return [
        openPositionRuleSet,
        depositRuleSet,
        withdrawRuleSet,
        burnRuleSet,
        stakeLPRuleSet,
        unstakeLPRuleSet,
        unstakeLPRuleSetTypeB,
        lpStakingRewardRuleSet,
        govStakeRuleSet,
        govUnstakeRuleSet,
        createPollRuleSet,
        castVoteRuleSet,
        airdropRuleSet,
        buySubmitOrderRuleSet,
        sellSubmitOrderRuleSet,
        cancelOrderRuleSet,
        buyExecuteOrderRuleSet,
        sellExecuteOrderRuleSet,
        lpStakeRuleSet,
        borrowRuleSet,
        unlockAmountRuleSet,
    ];
};
exports.default = create;
//# sourceMappingURL=index.js.map